/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BulkPatientManagerAssignmentDTO } from '../models/BulkPatientManagerAssignmentDTO'
import type { BulkPatientManagerAssignmentResponseDTO } from '../models/BulkPatientManagerAssignmentResponseDTO'
import type { PatientManagerAssignmentDTO } from '../models/PatientManagerAssignmentDTO'
import type { PatientManagerAssignmentResponseDTO } from '../models/PatientManagerAssignmentResponseDTO'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class PatientManagerAssignmentsService {
    /**
     * Assign Patient Manager
     * Assign or remove a patient manager from a patient or candidate.
     *
     * This endpoint allows you to:
     * - Assign a patient manager to either a patient or a candidate by providing the patient manager ID
     * - Remove an existing assignment by setting patientManagerId to null
     * - Update an existing assignment by providing a different patient manager ID
     *
     * The operation is idempotent - calling it multiple times with the same parameters will have the same effect.
     * @returns PatientManagerAssignmentResponseDTO Successful Response
     * @throws ApiError
     */
    public static assignPatientManagerPatientManagerAssignmentsPost({
        requestBody
    }: {
        requestBody: PatientManagerAssignmentDTO
    }): CancelablePromise<PatientManagerAssignmentResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/patient-manager-assignments',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Bulk Assign Patient Manager
     * Bulk assign or remove a patient manager from multiple patients or candidates.
     *
     * This endpoint allows you to:
     * - Assign a patient manager to multiple patients OR candidates in a single request
     * - Remove existing assignments by setting patientManagerId to null
     *
     * The operation processes all assignments and returns detailed results for each.
     * Partial success is possible - some assignments may succeed while others fail.
     * @returns BulkPatientManagerAssignmentResponseDTO Successful Response
     * @throws ApiError
     */
    public static bulkAssignPatientManagerPatientManagerAssignmentsBulkPost({
        requestBody
    }: {
        requestBody: BulkPatientManagerAssignmentDTO
    }): CancelablePromise<BulkPatientManagerAssignmentResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/patient-manager-assignments/bulk',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
}
